
import { LoggerInterface } from "../types/logger";
import { callApiInstance } from "./api";

class LoggerService {

  async uploadLog(data: LoggerInterface) {
    return (await callApiInstance({ url: "/MfaLogs", method: "POST", data })).data;
  }

}
export const loggerService = new LoggerService();
